import { Modal, Input } from "antd";
import React, { useEffect, useState } from "react";
import { EnvironmentOutlined } from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";
// This is a temporary copy of the style filter with the name changed for showing example filters for the contact page
export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState(null)
    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <EnvironmentOutlined /> City
            </FilterButton>
            <Modal
                title='City Filter'
                visible={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            cityFilter: {
                                text: 'City: ',
                                value: value
                            },
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                <Input
                    placeholder='Please input city'
                    defaultValue={value}
                    onChange={(e) => {
                        setValue(e.target.value)
                    }}
                />
            </Modal>
        </>
    )
}